import { Empty, Button } from 'antd';
import styles from './index.module.scss';
import { useRouter } from "next/router";
import {EmptyIcon} from "@/config/config";
import gaTracker from "@/ga";
import Image from "next/image";
import useLanguage from "@/hooks/useLanguage";
const CustomEmpty = ({ result, routerAddress, showRec = true, showResult = true }) => {
  const {t} = useLanguage();
  const router = useRouter();
  const refresh = () => {
    gaTracker.trackEvent("home_rec", true);
    if (routerAddress) {
      router.push(routerAddress);
    } else {
      window.location.href = window.location.origin;
    }

  };

  return (
    <div className={styles.Empty_container}>
      <div className={styles.container}>
        <div>
          <Image alt={""} width={393} height={341} className={"w-[393px] h-[341px] object-top object-cover"} src={"/images/empty-icon.svg"}></Image>
        </div>
        {
          showResult && <div className={styles.msg}>
            {result}
          </div>
        }
        {
          showRec && <div onClick={refresh} className={styles.btn}>
            {t('empty.recommend')}
          </div>
        }
      </div>
    </div>
  );
};
export default CustomEmpty;
